import { Label } from "@inkblot-therapy/squid"
import { Icon } from "../Icon"
import { useTranslation } from "react-i18next"

export const UploadEditInfo = () => {
  const { t } = useTranslation()

  return (
    <div className="flex mt-5 bg-[#F7F8FC] rounded-lg">
      <div className="pt-5 pl-5">
        <Icon
          variant="PencilAlt"
          className="text-[#869191] bg-[#EBECF2] rounded-full p-3"
          wrapped={true}
        />
      </div>
      <div className="block p-5">
        <Label className="block">
          {t("client.uploadCsv.landingPage.editTitle")}
        </Label>
        <Label strong={false}>
          {t("client.uploadCsv.landingPage.editSubtitle")}
        </Label>
      </div>
    </div>
  )
}
